import script from "./Rive.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rive.vue?vue&type=script&setup=true&lang=ts"

import "./Rive.vue?vue&type=style&index=0&id=35c8461b&lang=scss"

const __exports__ = script;

export default __exports__